import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const readOnly = props.readOnly || props.disabled;
  return (
    <input
      type={type}
      className={cn(
        // 2-px border via ring so it stays visible in BOTH light & dark
        // (`border-input` alone was too close to the card colour in one of
        // the themes and became invisible). Editable inputs use the primary
        // tint on focus so operators can see which field is active.
        "flex h-9 w-full rounded-md px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 disabled:cursor-not-allowed md:text-sm border-2",
        readOnly
          ? "bg-secondary/40 border-border text-foreground/60"
          : "bg-background border-input text-foreground hover:border-primary/50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
